import { createFileRoute } from "@tanstack/react-router";
import { SuggestionsList } from "@/components/University/suggestions/SuggestionsList";

export const Route = createFileRoute("/_authenticated/atlas/suggestions/")({
  component: SuggestionsList,
  staticData: { page: "university" },
});
